import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";

import { Observable } from "rxjs/Observable";

@Injectable()
export class SubStateInterceptor implements HttpInterceptor {
	addAuthHeader(request) {
		// let sub_state = localStorage.getItem("sub_state");
		// if (sub_state) {
		// 	request = request.clone({
		// 		setHeaders: {
		// 			sub_state: sub_state
		// 		}
		// 	});
		// }
		return request;
	}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		req = this.addAuthHeader(req);

		return next.handle(req).pipe();
	}
}
